import React from 'react';
import GenericDialogue from 'src/components/Dialogue/Dialogue';
import Loader from 'src/components/Loader';
import Button from 'src/components/Button';
import BulkAddKeyPickups from 'src/components/BulkOperations/BulkAddKeyPickups/BulkAddKeyPickups';
import BulkKeyPickupSummary from 'src/components/BulkOperations/BulkKeyPikcupSummary/BulkKeyPikcupSummary';
import { usePropertySuites } from 'src/SharedCustomHooks/UsePropertySuites/usePropertySuites';

interface BulkAddKeyPickupsProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
  selectedSuiteIds: string[];
  onSave?: (params: any) => void;
  propertyId: any;
  isLoading: any;
  onSetBulkSuccess: () => void;
  bulkKeyPickupsCreated: any;
}

export const BulkAddKeyPickupsDialogue = ({
  isOpen,
  onClose,
  userId,
  selectedSuiteIds,
  onSave,
  propertyId,
  isLoading,
  onSetBulkSuccess,
  bulkKeyPickupsCreated,
}: BulkAddKeyPickupsProps) => {
  const {
    suites,
    isLoading: suitesLoading,
    error: suitesError,
    refetch: refetchSuites,
  } = usePropertySuites({
    propertyId,
    userId,
    enabled: isOpen,
  });

  const handleClose = () => {
    onSetBulkSuccess();
    onClose();
  };

  const handleRetry = () => {
    refetchSuites();
  };

  if (isLoading || suitesLoading) {
    return (
      <GenericDialogue
        isOpen={isOpen}
        onClose={handleClose}
        title=""
        description=""
      >
        <Loader center={true} />
      </GenericDialogue>
    );
  }

  if (suitesError) {
    return (
      <GenericDialogue
        isOpen={isOpen}
        onClose={handleClose}
        title="Bulk Add Key Pickups"
        description="Add key pickups to multiple suites at once"
      >
        <div className="bulk-add-key-pickups__error">
          <p>Error: {suitesError}</p>
          <Button
            color="teal"
            size="small"
            label="Retry"
            onClick={handleRetry}
          />
        </div>
      </GenericDialogue>
    );
  }

  return (
    <GenericDialogue
      isOpen={isOpen}
      onClose={handleClose}
      title={
        bulkKeyPickupsCreated.length > 0
          ? 'Key Pickups Configured'
          : 'Bulk Add Key Pickups'
      }
      description={
        bulkKeyPickupsCreated.length > 0
          ? 'Summary of configured key pickups'
          : 'Add key pickups to multiple suites at once'
      }
    >
      {bulkKeyPickupsCreated.length > 0 ? (
        <BulkKeyPickupSummary createdKeyPickups={bulkKeyPickupsCreated} />
      ) : (
        <BulkAddKeyPickups
          userId={userId}
          selectedSuiteIds={selectedSuiteIds}
          onSave={onSave}
          suites={suites}
          propertyId={propertyId}
        />
      )}
    </GenericDialogue>
  );
};

export default BulkAddKeyPickupsDialogue;
